<script>
  import { algoliaClientId, algoliaSearchKey } from '../tenant';
  import { onMount } from 'svelte';
  import { push } from 'svelte-spa-router';
  import { isAuthenticated, userInfo, authToken } from '@dopry/svelte-auth0';
  import {
    Button,
    Container,
    Row,
    Col,
    TabContent,
    TabPane,
    Table,
  } from 'sveltestrap';
  import Refinement from './Refinement.svelte';
  import OrderItem from './OrderItem.svelte';
  import OrderModalOk from './OrderModalOk.svelte';
  import OrderModalError from './OrderModalError.svelte';
  import OrderModalCancel from './OrderModalCancel.svelte';
  import Pager from './Pager.svelte';
  import algoliasearch from 'algoliasearch/lite';
  import _ from 'lodash-es';
  import { money } from '../util';

  export let mode; // order | approve
  console.log('mode:', mode);

  let search = {
      hits: [],
      facets: { accountingClassification: [], category: [] },
    },
    cart = [],
    q = '',
    facets = [],
    roleClass = [],
    showItem = false,
    page = 0,
    stores = [],
    storeSelection = '',
    orderTotal = 0,
    statusMessage = '',
    objectID = -1,
    preApprovals = [],
    approvals = [],
    approved = false,
    comments = '',
    openOk = false,
    openError = false,
    openCancel = false;
  const fts = {
    catalog: algoliasearch(algoliaClientId, algoliaSearchKey).initIndex(
      'catalog'
    ),
    order: algoliasearch(algoliaClientId, algoliaSearchKey).initIndex('order'),
  };

  const sameItem = (x, y) => x.name === y.name;

  const rollClassMapping = {
    orderInventory: 'Inventory',
    orderNonInventory: 'Non-Inventory',
    orderCapex: 'Capital Expense',
  };

  const rolesToClasses = (roles) =>
    roles
      .filter((x) => x.startsWith('order'))
      .map((x) => rollClassMapping[x] || 'unassigned');

  const calculateOrderTotals = () =>
    (orderTotal = cart.reduce(
      (total, row) => (row?.qty || 0) * row.price + total,
      0
    ));

  const cartToCatalog = (name, value) => {
    try {
      _.find(search.hits, (x) => x.name === name).qty = parseFloat(value);
      search.hits = search.hits;
      calculateOrderTotals();
    } catch {}
  };
  const catalogToCart = (name) => {
    const item = _.find(search.hits, (x) => x.name === name);
    if (!isNaN(parseInt(item.qty))) {
      cart = _.uniqWith([item, ...cart], sameItem);
      calculateOrderTotals();
    }
  };

  const compose = (ctx, tuple) =>
    tuple.length ? `(${tuple.map((x) => `${ctx}:"${x}"`).join(' OR ')})` : '';

  const handleSearch = () => {
    console.log(
      `search: q=${q}, facets=${facets}, roleClass=${roleClass}, page=${page}`
    );
    let filters = [];
    if (facets.length) {
      const f = facets.toString();
      if (
        f.indexOf('accountingClassification:') > -1 &&
        f.indexOf('category:') > -1
      ) {
        console.log('zapping class filter(s)...');
        filters.push(
          `(${facets.filter((x) => x.startsWith('category:')).join(' OR ')})`
        );
      } else filters.push(`(${facets.join(' OR ')})`);
    }
    if (roleClass.length)
      filters.push(compose('accountingClassification', roleClass));
    filters = filters.join(' AND ');
    if (!showItem) filters += ' AND NOT showItem:true'; // custom catalog hack
    console.log(`filters: ${filters}`);
    fts.catalog
      .search(q, {
        facets: ['accountingClassification', 'category'],
        filters,
        hitsPerPage: 50,
        page,
        attributesToHighlight: [],
      })
      .then((result) => {
        search = result;
        search.hits = search.hits.map((x) => ({ ...x, qty: 0 }));
        cart.forEach((x) => cartToCatalog(x.name, x.qty));
        console.log('catalog search:', search);
      })
      .catch((e) => console.log(e));
  };

  const handleOrder = () => {
    const orderItems = cart.filter((x) => x.qty > 0),
      orderTotal = orderItems.reduce(
        (accum, item) => accum + item.price * item.qty,
        0
      ),
      orderErrors = orderItems.filter(
        (x) => x.qty % x.quantity > 0 || x.qty > x.maxQuantity
      );
    let order;
    if (
      orderErrors.length == 0 &&
      orderItems.length - orderErrors.length > 0 &&
      ((mode == 'order' && storeSelection) ||
        (mode != 'order' && objectID != -1))
    ) {
      if (mode == 'order') {
        const { store, storeName, market, marketName } = stores.filter(
          (x) => x.store == storeSelection
        )[0];
        order = {
          store: Number(store),
          storeName: storeName,
          market: Number(market),
          marketName: marketName,
          orderItems,
          orderTotal,
          approvable: true,
          source: 'oo',
        };
      } else {
        order = {
          objectID,
          approved,
          approvable: false,
          comments,
          approveItems: JSON.stringify(preApprovals) == JSON.stringify(orderItems) ? null : orderItems,
          approvalTotal: orderTotal,
        };
      }
      console.log('order:', order);
      if ($isAuthenticated && $authToken) {
        // verify approver of mode appropriate...
        fetch(mode == 'order' ? 'api/orderSave' : 'api/orderUpdate', {
          method: 'POST',
          headers: { Authorization: `Bearer ${$authToken}` },
          body: JSON.stringify(order),
        })
          .then((result) => result.json())
          .then((result) => {
            console.log('apiResult:', result);
            if (result?.status == 401) throw new Error(result?.msg);
            cart = [];
            if (mode == 'order') storeSelection = '';
            else {
              approvals = approvals.filter((x) => x.objectID != objectID);
              objectID = -1;
              comments = '';
            }
            cart = cart;
            openOk = true;
          })
          .catch((e) => {
            console.log('apiError:', e);
            alert(`please contact support with the following concern: ${e}`);
          });
      }
    } else {
      statusMessage = `Your ${
        mode == 'order' ? 'order' : 'approval'
      } cannot be submitted yet, please fix the following:<br/><br/>`;
      if (mode == 'order') {
        if (!storeSelection)
          statusMessage += ' - No store selected, please select a store.<br/>';
      } else {
        if (objectID == -1)
          statusMessage +=
            ' - No order selected, please select an unapproved order.<br/>';
      }
      if (orderErrors.length > 0)
        statusMessage +=
          ' - Quantity errors, please verify the quantities highlighted yellow.<br/>';
      if (!orderItems.length)
        statusMessage +=
          ' - Your cart is empty, please specify quantities for one or more items.<br/>';
      openError = true;
    }
  };

  const handleOrderCancellation = () => {
    if (mode != 'order') {
      approved = false;
      handleOrder();
    }
    cart = [];
    calculateOrderTotals();
    cart = cart;
    search.hits.forEach((x) => (x.qty = 0));
    search = search;
  };

  const cartSelectedOrder = () => {
    cart = [];
    if (objectID != -1) {
      const order = approvals.filter((x) => x.objectID == objectID)[0];
      cart = order.orderItems;
      preApprovals = [...order.orderItems];
      orderTotal = order.orderTotal;      
      search.hits = search.hits.map((x) => ({ ...x, qty: 0 }));
      cart.forEach((x) => cartToCatalog(x.name, x.qty));
    }
    console.log('cartSelectedOrder cart:', cart);
  };

  onMount(async () => {
    if (!$isAuthenticated) push('/');
    if ($isAuthenticated && $userInfo) {
      console.log('user:', $userInfo);
      roleClass = rolesToClasses($userInfo['http://techsteward.com/roles']);
      console.log('roleClass:', roleClass);
      showItem = $userInfo['http://techsteward.com/roles'].includes('showItem');
      console.log('showItem:', showItem); // custom catalog hack
      handleSearch();
      cart.forEach((x) => cartToCatalog(x.item, x.qty));
      const userStores =
          $userInfo['http://techsteward.com/app_metadata'].stores || [],
        approvalsFilter = [userStores.map((x) => `store = ${x}`)];
      const result = await fetch('data/stores.json');
      stores = await result.json();
      stores = stores.filter((x) => userStores.includes(x.store));
      console.log('userStores:', userStores);
      console.log('approvalsFilter:', approvalsFilter);
      if (mode != 'order') {
        fts.order
          .search('', {
            facetFilters: ['approvable:true'],
            numericFilters: approvalsFilter,
            hitsPerPage: 1000,
            page,
            attributesToHighlight: [],
          })
          .then((result) => {
            approvals = result.hits;
            console.log('initial approvals:', approvals);
          })
          .catch((e) => console.log(e));
      }
    }
  });

  $: {
    if (objectID != -1) cartSelectedOrder();
    else cartSelectedOrder();
  }
</script>

<Container>
  {#if mode != 'order'}
    <div>
      Unapproved Orders:
      <select bind:value={objectID}>
        <option value="-1">select an order to approve...</option>
        {#each approvals as order}
          <option value={order.objectID}>
            {order.orderDate}
            for store {order.storeName} ({order.marketName}) w/ {order
              .orderItems.length} items @ {money.format(order.orderTotal)}
          </option>
        {/each}
      </select>
    </div>
    <br />
  {/if}
  <TabContent>
    <TabPane tabId="catalog" tab="Catalog" active={mode == 'order'}>
      <br />
      <div doc="fts">
        <input
          style="width: 500px"
          class="input"
          type="text"
          placeholder="optional search..."
          on:change={handleSearch}
          bind:value={q}
        />
        <button class="button is-primary" on:click={handleSearch}>
          <span class="icon">Search</span>
        </button>
      </div>
      <br />
      <Row>
        <Col xs="3" doc="refinement">
          <div id="refinement">
            <h5>Refine</h5>
            <Refinement
              title="Class"
              attribute="accountingClassification"
              {search}
              bind:facets
              bind:page
              action={handleSearch}
            />
            <Refinement
              title="Category"
              attribute="category"
              {search}
              bind:facets
              bind:page
              action={handleSearch}
            />
          </div>
        </Col>
        <Col xs="9" doc="results">
          <div id="results">
            <h5>
              Results
              <span>({search.nbHits} hits in {search.processingTimeMS}ms)</span>
            </h5>
            <Table striped>
              <tbody>
                {#each search.hits as item}
                  <OrderItem {item} action={catalogToCart} />
                {/each}
              </tbody>
            </Table>
            <Pager {search} bind:page action={handleSearch} />
          </div>
        </Col>
      </Row>
    </TabPane>
    <TabPane
      tabId="cart"
      tab={mode == 'order' ? 'Order Cart' : 'Approval Cart'}
      active={mode != 'order'}
    >
      <br />
      <Table striped>
        <tbody>
          {#each cart as item}
            <OrderItem {item} action={cartToCatalog} />
          {/each}
        </tbody>
      </Table>
      <div>
        <div>
          <br />
          Order Total:
          <strong>{money.format(orderTotal)}</strong>
          (orders greater than $350 get free shipping!)
        </div>
        <br />
        {#if mode == 'order'}
          <div class="field">
            <label for="store" class="label">Store</label>
            <div class="control select">
              <select id="store" bind:value={storeSelection} class="input">
                <option value="" disabled selected>select a store...</option>
                {#each stores as s}
                  <option value={s.store}>{s.storeName}</option>
                {/each}
              </select>
            </div>
          </div>
        {:else}
          <div>Comments:</div>
          <textarea bind:value={comments} rows="5" cols="65" />
          <br />
        {/if}
        <br />
        <Button
          on:click={() => {
            approved = true;
            handleOrder();
          }}
          color="primary"
          >{`Submit ${mode == 'order' ? 'Order' : 'Approval'}`}</Button
        >
        <Button on:click={() => (openCancel = true)} color="danger"
          >{`${
            mode == 'order' ? 'Cancel Order' : 'Unapprove Approval !!!'
          }`}</Button
        >
      </div>
    </TabPane>
  </TabContent>
</Container>

<OrderModalOk bind:open={openOk} {mode} />
<OrderModalError bind:open={openError} {mode} {statusMessage} />
<OrderModalCancel
  bind:open={openCancel}
  {mode}
  handler={handleOrderCancellation}
/>
